"use client";
import React from "react";
const FlyoutContext = React.createContext({});
const FlyoutTriggerContext = React.createContext(null);
const FlyoutContentContext = React.createContext(null);
const useFlyoutContext = () => React.useContext(FlyoutContext);
const useFlyoutTriggerContext = () => React.useContext(FlyoutTriggerContext);
const useFlyoutContentContext = () => React.useContext(FlyoutContentContext);
const Provider = FlyoutContext.Provider;
const TriggerProvider = FlyoutTriggerContext.Provider;
const ContentProvider = FlyoutContentContext.Provider;
export { Provider, TriggerProvider, ContentProvider, useFlyoutContext, useFlyoutTriggerContext, useFlyoutContentContext, };
export default FlyoutContext;
